import { PageVisit } from './primitives/a-page';
import { identify } from './primitives/a-identify';
import { createEarnTabEvent } from './events/earn-tab';
import { createWalletEvent } from './events/wallet-events';
import { createTradeTabEvent } from './events/trade-tab';
import { createVariousEvent } from './events/various-event';
import { createSuccessEvent } from './events/success-event';
import { createFailureEvent } from './events/failure-event';
import { createWhitelistEvent } from './events/whitelist-events';
const visitPage = new PageVisit();
export { visitPage, identify, createWalletEvent, createEarnTabEvent, createTradeTabEvent, createVariousEvent, createSuccessEvent, createFailureEvent, createWhitelistEvent };
//# sourceMappingURL=main.js.map